import React, { useCallback, useEffect, useState, Children } from "react";
import { Alert, Button, Form, Modal, Spinner } from "react-bootstrap";
import { useLang } from "../../../../../../language";
import { AlquileresServices, AlquilerServices } from "../services/alquileres.service";
import { getParseDate, isStatusError, isStatusSucess } from "../../../../../../helpers/helpers";
import { useValidator } from "../../../../../../hooks/useValidator";
import { cloneDeep } from "lodash";
import { Calendar, momentLocalizer } from 'react-big-calendar'

import moment from 'moment'
import { useForm } from "../../../../../../hooks/useForm";
import { receiveFecha, receiveFechaFormat2 } from "../../../../../../adapters/helpers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar, faSave } from "@fortawesome/free-solid-svg-icons";

const localizer = momentLocalizer(moment)
require('moment/locale/ca.js')

export const ModalFechasCalendario = ({ data, handleClose, handleShow, idpedido, idproducto, handleUpdateDates }: any) => {

    const [messageValid, setmessageValid] = useState({
        status: 0,
        message: ''
    });

    const Lang = useLang()

    const [events, setEvents] = useState<any>([])

    const [formInscripcion, handleInputInscripcion, handleFormInscripcion, resetFormInscripcion] = useForm({
        fechadesde: '',
        fechahasta: '',
    })

    const lang = {
        ca: {
            week: 'Setmana',
            work_week: 'Setmana de treball',
            day: 'Dia',
            month: 'Mes',
            previous: '<',
            next: '>',
            today: 'Avui',
            agenda: 'El Diari',

            showMore: (total: any) => `+${total} més`,
        }
    }

    const [formDatosGenerales, handleInputDatosGenerales, handleFormDatosGenerales, resetDatosGenerales] = useForm({
        // ...InformacionAdicionalAdapters.GET.receive.schema({}),
        title: Lang('EVENTO'),
    })

    const [valuesValidationEvento, handleValidationEvento, handleResetValidationEvento] = useValidator({
        horainicio: { isOk: true, msgError: [Lang('ALERT_OBLIGATORIO_GENERICO')] },
        horafin: { isOk: true, msgError: [Lang('ALERT_OBLIGATORIO_GENERICO')] },
    })

    const [startEndDates, setStartEndDates] = useState<any>({});

    const [objFechasData, setObjFechasData] = useState<any>({});

    const [startEndSlot, setStartEndSlot] = useState<any>({
        start: '',
        end: '',
    });

    const getStartAndEndDate = (date: Date) => {

        const firstDay = moment(new Date(date.getFullYear(), date.getMonth(), 1)).format('YYYY-MM-DD');
        const lastDay = moment(new Date(date.getFullYear(), date.getMonth() + 1, 0)).format('YYYY-MM-DD');

        setStartEndDates({
            fechainicio: firstDay,
            fechafin: lastDay,
        })
    };

    const onNavigate = useCallback((date: Date) => {
        getStartAndEndDate(date);
    }, []);


    const ColoredDateCellWrapper = useCallback(({ children, value }: any) => {

        let color = ''

        const diaActual = moment(new Date(value)).format('YYYY-MM-DD')

        if (formDatosGenerales.horainicio === diaActual) {
            color = '#6bebb0'
        }

        // -------- Colorear slot seleccionado

        const startEndSlotTemp = cloneDeep(startEndSlot)

        let slotStart = startEndSlotTemp.start
        let slotEnd = startEndSlotTemp.end

        if (!slotEnd) slotEnd = slotStart

        if ((new Date(value))?.getTime() >= (new Date(slotStart + 'T00:00:00'))?.getTime() &&
            (new Date(value))?.getTime() <= (new Date(slotEnd + 'T00:00:00'))?.getTime()) {
            color = '#b0efbf'
        }

        // -------- Colorear dia festivo

        if (isFeriadoySabadoODomingo(value, startEndDates, objFechasData)) {
            color = '#ffe6e6'
        }

        return React.cloneElement(Children.only(children), {
            style: {
                ...children.style,
                backgroundColor: color,
            },
        })

    }, [startEndDates, formDatosGenerales.horainicio, startEndSlot, objFechasData])


    const isFeriadoySabadoODomingo = (value: any, startEndDates: any, objFechasData: any) => {

        const valueDate = new Date(value)

        const valueDateFormat = moment(new Date(value)).format('YYYY-MM-DD')

        const fechainicio = new Date(startEndDates.fechainicio)
        const fechafin = new Date(startEndDates.fechafin)

        if (fechainicio?.getTime() <= valueDate.getTime() && valueDate.getTime() <= fechafin?.getTime()) {

            if (valueDate.getDay() === 6 || valueDate.getDay() === 0 || (objFechasData[valueDateFormat] && objFechasData[valueDateFormat] !== 'diadecobro')) {

                return true
            }
        }

        return false
    }

    // useEffect(() => {

    //     getStartAndEndDate(new Date());

    //     setmessageValid({
    //         status: 0,
    //         message: ''
    //     })

    // }, [])

    const handleSelectSlot = useCallback(

        ({ start, end, title }: any) => {

            const startinputdate = String(getParseDate(new Date(start)) || '')

            // ------ Si no existen ambas fechas

            if (!startEndSlot.start && !startEndSlot.end) {

                setStartEndSlot({
                    ...startEndSlot,
                    start: startinputdate,
                })
            }

            // ------ Si existe la primera fecha

            if (startEndSlot.start && !startEndSlot.end) {

                if (startEndSlot.start === startinputdate) {

                    setStartEndSlot({
                        start: '',
                        end: '',
                    })

                } else if ((new Date(startEndSlot.start))?.getTime() <= (new Date(start))?.getTime()) {

                    setStartEndSlot({
                        ...startEndSlot,
                        end: startinputdate,
                    })

                    handleFormInscripcion({
                        ...formInscripcion,
                        fechadesde: startEndSlot.start,
                        fechahasta: startinputdate,
                    })

                } else {
                    setStartEndSlot({
                        start: startinputdate,
                        end: ''
                    })
                }

            }

            // ------ Si existe la segunda fecha

            if (startEndSlot.start && !startEndSlot.end) {

            }


            // ------ Si existen ambas fechas

            if (startEndSlot.start && startEndSlot.end) {

                setStartEndSlot({
                    start: startinputdate,
                    end: '',
                })

            }

        },
        [startEndSlot]
    )

    // Consultar disponibilidad

    const [fetchCheckDisponibilidad, fetchCheckDisponibilidadData] = AlquileresServices.GET_CHECK_DISPONIBILIDAD()

    useEffect(() => {

        if (isStatusSucess(fetchCheckDisponibilidadData.status)) {

            setObjFechasData(fetchCheckDisponibilidadData.data?.data)
        }

    }, [fetchCheckDisponibilidadData]);


    const [fetchCheckDisponibilidadClick, fetchCheckDisponibilidadClickData] = AlquileresServices.GET_CHECK_DISPONIBILIDAD()

    useEffect(() => {

        if (startEndDates.fechainicio && startEndDates.fechafin) {

            fetchCheckDisponibilidad({
                params: {
                    fechadesde: startEndDates.fechainicio,
                    fechahasta: startEndDates.fechafin,
                    estricto: false,
                    idpedido,
                    idproducto,
                }
            })
        }

    }, [startEndDates.fechainicio, startEndDates.fechafin]);


    useEffect(() => {

        if (startEndSlot.start && startEndSlot.end) {

            fetchCheckDisponibilidadClick({
                params: {
                    fechadesde: startEndSlot.start,
                    fechahasta: startEndSlot.end,
                    estricto: true,
                    idpedido,
                    idproducto,
                }
            })
        }

    }, [startEndSlot.start, startEndSlot.end]);


    useEffect(() => {

        if (isStatusSucess(fetchCheckDisponibilidadClickData.status)) {

            setmessageValid({
                status: 200,
                message: 'Les dates seleccionades són correctes',
            })
        }

        if (isStatusError(fetchCheckDisponibilidadClickData.status)) {

            setmessageValid({
                status: 400,
                message: fetchCheckDisponibilidadClickData?.error?.message,
            })
        }

    }, [fetchCheckDisponibilidadClickData]);

    useEffect(() => {

        if (data.value) {

            getStartAndEndDate(new Date());

            setmessageValid({
                status: 0,
                message: ''
            })

        } else {

            resetFormInscripcion()
            setStartEndDates({})
            setObjFechasData({})
            setStartEndSlot({
                start: '',
                end: '',
            })
        }

    }, [data.value]);

    return (
        <>
            <Button onClick={handleShow} >
                <FontAwesomeIcon icon={faCalendar} className="me-1" /> {Lang('CAMBIAR_FECHAS')}
            </Button>

            <Modal show={data.value} onHide={handleClose} id='ModalRegistro' size="lg">
                <Modal.Header closeButton className='border-bottom-0 py-4'>
                    <Modal.Title className='h5'>{Lang('GENERAR_FACTURA')}</Modal.Title>

                </Modal.Header>
                <Modal.Body className='px-4 py-0'>

                    <section className="row justify-content-center">

                        <div className="col-12">

                            <section className="position-relative">
                                <Calendar
                                    localizer={localizer}
                                    events={events}
                                    startAccessor="start"
                                    endAccessor="end"
                                    style={{ height: 400 }}
                                    // onSelectEvent={handleSelectEvent}
                                    onSelectSlot={handleSelectSlot}
                                    culture='ca'
                                    messages={lang['ca']}
                                    views={
                                        {
                                            month: true
                                        }
                                    }
                                    selectable
                                    components={{
                                        dateCellWrapper: ColoredDateCellWrapper
                                    }}
                                    onNavigate={onNavigate}

                                />
                                {
                                    fetchCheckDisponibilidadData.loading &&
                                    <div className="d-flex py-5 justify-content-center align-items-center OverlayCalendar__Loading">
                                        <Spinner animation="border" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </Spinner>
                                    </div>
                                }
                            </section>
                        </div>

                        <div className="text-center">
                            {
                                fetchCheckDisponibilidadClickData.loading ?
                                    <div className="pt-4">
                                        <Spinner animation="border" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </Spinner>
                                    </div>
                                    :
                                    <>
                                        {
                                            messageValid.message ?
                                                <div className="col-12 mt-4">
                                                    <Alert variant={messageValid?.status === 200 ? 'success' : 'danger'} className='my-0 py-2 text-center'>
                                                        {messageValid?.message}: {receiveFechaFormat2(receiveFecha(formInscripcion.fechadesde))} - {receiveFechaFormat2(receiveFecha(formInscripcion.fechahasta))}
                                                    </Alert>
                                                </div>
                                                :
                                                <></>
                                        }
                                    </>
                            }
                        </div>

                    </section>

                </Modal.Body>
                <Modal.Footer className='border-0 d-flex justify-content-between'>
                    <div></div>
                    {
                        messageValid?.status === 200 &&
                        <Button className="btn btn-primary" onClick={() => {
                            handleUpdateDates(startEndSlot.start, startEndSlot.end)
                        }}>
                            <FontAwesomeIcon icon={faSave} className='me-1' />{Lang('GUARDAR')}
                        </Button>
                    }
                </Modal.Footer>
            </Modal>
        </>
    )
};
